import {ACTION} from './constants';
import request from '../../../../utils/request';
import {requestConfig} from "../../../../config/apiResource";
import {showMainLoader, hideMainLoader} from '../../../actions';

export function getCareerContent() {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getCareersContent())
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_CAREERS_CONTENT , data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with careers content: " + error)
            });
    }
}

